import { z } from 'zod';

import {
  ANNUAL_INCOME_VALUES,
  NET_WORTH_VALUES,
  TRADING_EXPERIENCE_VALUES,
} from '../../constants/kyc.const';

export const TradingExperiencePayloadSchema = z.object({
  annual_income: z.enum(ANNUAL_INCOME_VALUES),
  net_worth: z.enum(NET_WORTH_VALUES),
  experience_level: z.enum(TRADING_EXPERIENCE_VALUES),
});

export const VerifyMarketKycPayloadSchema = z.object({
  ssn: z.string(),
  trading_experience: TradingExperiencePayloadSchema,
  session_id: z.string().optional(),
});

export const MarketTradingStatusSchema = z
  .enum(['pending', 'approved', 'denied', 'unknown'])
  .catch('unknown');

export const MarketKycDocvStatusSchema = z
  .enum(['pending', 'approved', 'denied', 'unknown'])
  .catch('unknown');

export const MarketKycDocvSchema = z.object({
  url: z.string(),
  qrCode: z.string().optional(),
  docvTransactionToken: z.string(),
  eventId: z.string().optional(),
  sdkKey: z.string().optional(),
});

export const VerifyMarketKycResponseSchema = z.object({
  trading_status: MarketTradingStatusSchema,
  docv: MarketKycDocvSchema.optional(),
  kyc_docv_status: MarketKycDocvStatusSchema.optional(),
});

export type TradingExperiencePayload = z.infer<typeof TradingExperiencePayloadSchema>;
export type VerifyMarketKycPayload = z.infer<typeof VerifyMarketKycPayloadSchema>;
export type MarketTradingStatus = z.infer<typeof MarketTradingStatusSchema>;
export type MarketKycDocvStatus = z.infer<typeof MarketKycDocvStatusSchema>;
export type MarketKycDocv = z.infer<typeof MarketKycDocvSchema>;
export type VerifyMarketKycResponse = z.infer<typeof VerifyMarketKycResponseSchema>;
